import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { RegularWrapper } from 'components/common';
import { Wrapper, Title, Block, InputWrapper } from './Contacts.styles';
import InputPhone from 'components/common/InputPhone/InputPhone';

const Contacts = ({ value, onChange, errors }) => {
  const { t } = useTranslation();

  const [currentValue] = value;
  const [error] = errors;

  const onChangeField = (field) => (e) => {
    const currentValue = e?.target ? e.target.value : e;

    onChange([{ ...value[0], [field]: currentValue.trim() }]);
  };

  return (
    <Wrapper>
      <Title>{t('Settings.Person.Card.Contacts')}</Title>
      <Block>
        <RegularWrapper gap="12px" align="center">
          <InputWrapper width="260px">
            <InputPhone onChange={onChangeField('phone')} value={currentValue?.phone} error={error?.phone} />
          </InputWrapper>
        </RegularWrapper>
      </Block>
    </Wrapper>
  );
};

Contacts.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.array,
  errors: PropTypes.array,
};

export default Contacts;
